import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
const getTranslatorFunc = props => get(props, 'translator.__') || get(props, '__') || (str => {
  console.error('Translate function has not been found!');
  return str;
});
const isEmpty = value => value === undefined || value === null || value === '' || Array.isArray(value) && value.length === 0;
const join = rules => (value, data, props) => rules.map(rule => rule(value, data, props)).filter(error => !!error)[0];
export function required(value, data, props) {
  if (isEmpty(value)) {
    return getTranslatorFunc(props)('Required');
  }
  return undefined;
}
export function url(value, data, props) {
  if (!isEmpty(value) && !/^([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i.test(value)) {
    return getTranslatorFunc(props)('Invalid URL');
  }
  return undefined;
}
export function maxLength(max) {
  return (value, data, props) => {
    if (!isEmpty(value) && value.length > max) {
      return getTranslatorFunc(props)('Must be no more than %(max)s characters', {
        max
      });
    }
    return undefined;
  };
}
function computeErrors(rules, data, props) {
  const errors = {};
  Object.keys(rules).forEach(key => {
    if (isPlainObject(rules[key])) {
      errors[key] = computeErrors(rules[key], data[key], props);
    } else {
      const rule = join([].concat(rules[key]));
      const error = rule(data ? data[key] : undefined, data, props);
      if (error) {
        errors[key] = error;
      }
    }
  });
  return errors;
}
export function createValidator(rules) {
  return (data = {}, props) => computeErrors(rules, data, props);
}
export function clean(errors) {
  if (!errors) return {};
  return Object.keys(errors).reduce((acc, key) => {
    if (isEmpty(errors[key])) {
      return acc;
    }
    return {
      ...acc,
      [key]: errors[key]
    };
  }, {});
}